import { render, staticRenderFns } from "./FIFAWorldCup_matchItem.vue?vue&type=template&id=c1f1ca90&scoped=true"
import script from "./FIFAWorldCup_matchItem.vue?vue&type=script&lang=js"
export * from "./FIFAWorldCup_matchItem.vue?vue&type=script&lang=js"
import style0 from "./FIFAWorldCup_matchItem.vue?vue&type=style&index=0&id=c1f1ca90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1f1ca90",
  null
  
)

export default component.exports